<ridango-block-full-width>
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>

    <h2 class="block-full-width__title">
        {{ 'CHOOSE_ZONE' | translate }}
    </h2>

    <div class="tablet-layout" ridangoMatchHeight="checkable-block">
        <div class="select-zone-area select-zone-area__left" *ngIf="showWholeCounty">
            <ridango-selectable-block-wrapper [selected]="allZonesSelected$ | async">
                <p class="block-full-width__title" *ngIf="!countySelected">
                    {{ 'STOPS_ZONES_TICKET_TEXT_CHOOSE_ALL_ZONES' | translate }}
                </p>

                <p class="block-full-width__title" *ngIf="countySelected">
                    {{ 'SELECTED_STOPS_ZONES_TICKET_TEXT_CHOOSE_ALL_ZONES' | translate }}
                </p>

                <p class="block-full-width__description">
                    <span>{{ 'STOPS_ZONES_TICKET_TEXT_ALL_ZONES' | translate }}</span>
                    <a
                        tabindex="0"
                        class="link--emphasized link--action"
                        (click)="openMapDialog()"
                        (keydown.enter)="openMapDialog()"
                        (keydown.space)="openMapDialog()"
                        >{{ 'CHOOSE_STOPS_CONSULT_MAP' | translate }}</a
                    >
                </p>

                <p class="block-full-width__description bold">{{ 'WHOLE_COUNTY_PRICE_DESCRIPTION' | translate }}</p>
                <button class="btn btn--secondary" (click)="toggleWholeCountySelected(); forgetTicketRenew()">
                    {{
                        (allZonesSelected$ | async)
                            ? ('DESELECT_WHOLE_COUNTY' | translate)
                            : ('CHOOSE_WHOLE_COUNTY' | translate)
                    }}
                </button>
            </ridango-selectable-block-wrapper>
        </div>

        <div class="select-zone-area__middle" *ngIf="showWholeCounty">
            <ridango-vertical-or-separator></ridango-vertical-or-separator>
        </div>

        <div class="select-zone-area" [ngClass]="{ 'select-zone-area__right': showWholeCounty }">
            <ridango-selectable-block-wrapper [selected]="(selectedOrigin$ | async) || (selectedDestination$ | async)">
                <p class="block-full-width__title" *ngIf="!travelBetweenZones && !oneZoneSelected">
                    {{ 'STOPS_ZONES_TEXT_CHOOSE_ZONE_RANGE' | translate }}
                </p>

                <p class="block-full-width__title" *ngIf="!travelBetweenZones && oneZoneSelected">
                    {{ 'SELECTED_STOPS_ZONES_TICKET_TEXT_CHOOSE_ONE_ZONE' | translate }}
                </p>

                <p class="block-full-width__title" *ngIf="travelBetweenZones">
                    {{ 'STOPS_ZONES_SELECT_ZONES_TITLE' | translate }}
                </p>

                <p class="block-full-width__description" *ngIf="!travelBetweenZones">
                    <span>{{ 'STOPS_ZONES_TICKET_TEXT_SELECT_ZONE' | translate }}</span>
                    <a
                        tabindex="0"
                        class="link--emphasized link--action"
                        (click)="openMapDialog()"
                        (keydown.enter)="openMapDialog()"
                        (keydown.space)="openMapDialog()"
                        >{{ 'CHOOSE_STOPS_CONSULT_MAP' | translate }}</a
                    >
                </p>

                <p class="block-full-width__description" *ngIf="travelBetweenZones">
                    <span>{{ 'STOPS_ZONES_SELECT_ZONES_DESCRIPTION' | translate }}</span>
                    <a
                        tabindex="0"
                        class="link--emphasized link--action"
                        (click)="openMapDialog()"
                        (keydown.enter)="openMapDialog()"
                        (keydown.space)="openMapDialog()"
                        >{{ 'CHOOSE_STOPS_CONSULT_MAP' | translate }}</a
                    >
                </p>

                <ridango-dropdown-filter-wcag
                    [items]="filteredZones$ | async"
                    [selectedItem]="selectedOrigin$ | async"
                    [filter]="(selectedOrigin$ | async)?.display"
                    (onItemSelected)="originZoneSelected($event)"
                    (click)="forgetTicketRenew()"
                    [placeholder]="'PH_SELECT_ZONE'">
                </ridango-dropdown-filter-wcag>

                <ridango-dropdown-filter-wcag
                    *ngIf="travelBetweenZones"
                    [items]="filteredZones$ | async"
                    [selectedItem]="selectedDestination$ | async"
                    [filter]="(selectedDestination$ | async)?.display"
                    (onItemSelected)="destinationZoneSelected($event)"
                    [placeholder]="'PH_SELECT_ZONE'">
                </ridango-dropdown-filter-wcag>
            </ridango-selectable-block-wrapper>
        </div>
    </div>
</ridango-block-full-width>
